/**
 * Bridges gesture-time media failures into CallingScreen before placeCall runs.
 * Used when Start Call acquires media under tap, then navigates to /call.
 */

/** @type {object | null} */
let pendingCallMediaError = null;

/** When true, CallingScreen must not auto-place until Allow access succeeds. */
let blockOutgoingPlaceCall = false;

export function setPendingCallMediaError(error) {
  pendingCallMediaError = error || null;
  blockOutgoingPlaceCall = Boolean(error);
}

export function consumePendingCallMediaError() {
  const next = pendingCallMediaError;
  pendingCallMediaError = null;
  return next;
}

export function peekPendingCallMediaError() {
  return pendingCallMediaError;
}

export function shouldBlockOutgoingPlaceCall() {
  return blockOutgoingPlaceCall;
}

export function clearOutgoingPlaceCallBlock() {
  blockOutgoingPlaceCall = false;
}
